import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { User } from '../models';
import {AccountService} from "./account.service";
import {Items} from "../models/items";

@Injectable({ providedIn: 'root' })
export class UserService {
    constructor(
        private router: Router,
        private http: HttpClient,
        private accountService: AccountService
    ) {

    }

    getAll() {
        return this.http.get<Items>(`${environment.apiEndpoint}/v1/user`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getAllCustomers() {
        return this.http.get<Items>(`${environment.apiEndpoint}/v1/user?filters[roles]=ROLE_CUSTOMER`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getAllTrainers() {
        return this.http.get<Items>(`${environment.apiEndpoint}/v1/user?filters[roles]=ROLE_TRAINER`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getAllCustomersPaged(offset: number, limit: number, filters?: any[], sort?: any[]) {
        let filtersStr = '';

        if (filters && filters['createdAt'] && filters['createdAtTo']) {
            filtersStr += '&filters[createdAt]=' + filters['createdAt'] + '&filters[createdAtTo]=' + filters['createdAtTo'];
        } else if (filters && filters['firstSaleFrom'] && filters['firstSaleTo']) {
            filtersStr += '&filters[firstSaleFrom]=' + filters['firstSaleFrom'] + '&filters[firstSaleTo]=' + filters['firstSaleTo'];
        } else if (filters && filters['firstOnlineSaleFrom'] && filters['firstOnlineSaleTo']) {
            filtersStr += '&filters[firstOnlineSaleFrom]=' + filters['firstOnlineSaleFrom'] + '&filters[firstOnlineSaleTo]=' + filters['firstOnlineSaleTo'];
        } else if (filters && filters['firstTraditionalSaleFrom'] && filters['firstTraditionalSaleTo']) {
            filtersStr += '&filters[firstTraditionalSaleFrom]=' + filters['firstTraditionalSaleFrom'] + '&filters[firstTraditionalSaleTo]=' + filters['firstTraditionalSaleTo'];
        } else if (filters && filters['registrationSource'] && filters['registrationSource']) {
            filtersStr += '&filters[registrationSource]=' + filters['registrationSource'];
        }

        if (sort && sort['sortDir'] && sort['sortCol']) {
            filtersStr += '&sortDir=' + sort['sortDir'] + '&sortCol=' + sort['sortCol'];
        }

        return this.http.get<Items>(`${environment.apiEndpoint}/v1/user?filters[roles]=ROLE_CUSTOMER&offset=` + offset + '&limit=' + limit + filtersStr, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getAllCustomersBy(value: string) {
        return this.http.get<Items>(`${environment.apiEndpoint}/v1/user?filters[roles]=ROLE_CUSTOMER&filters[allFields]=` + value, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    findCustomerByFirstNameAndLastName(firstName: string, lastName: string) {
        return this.http.get<Items>(`${environment.apiEndpoint}/v1/user?filters[roles]=ROLE_CUSTOMER&filters[firstName]=` + firstName + `&filters[lastName]=` + lastName, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getAllWorkers() {
        return this.http.get<Items>(`${environment.apiEndpoint}/v1/user?filters[roles]=ROLE_WORKER`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getAllWorkersPaged(offset: number, limit: number) {
        return this.http.get<Items>(`${environment.apiEndpoint}/v1/user?filters[roles]=ROLE_WORKER&offset=` + offset + '&limit=' + limit, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getAllTrainersPaged(offset: number, limit: number) {
        return this.http.get<Items>(`${environment.apiEndpoint}/v1/user?filters[roles]=ROLE_TRAINER&offset=` + offset + '&limit=' + limit, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getAllWorkersBy(value: string) {
        return this.http.get<Items>(`${environment.apiEndpoint}/v1/user?filters[roles]=ROLE_WORKER&filters[allFields]=` + value, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getAllResources() {
        return this.http.get<Items>(`${environment.apiEndpoint}/v1/user?filters[roles]=ROLE_RESOURCE`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getAllResourcesVisibleInCalendar() {
        return this.http.get<Items>(`${environment.apiEndpoint}/v1/user?filters[roles]=ROLE_RESOURCE&filters[visibleInCalendar]=1`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getAllWorkersByPriority() {
        return this.http.get<Items>(`${environment.apiEndpoint}/v1/user?filters[roles]=ROLE_WORKER&sortCol=calendarPriority&sortDir=ASC`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getAllWorkersVisibleInCalendarByPriority() {
        return this.http.get<Items>(`${environment.apiEndpoint}/v1/user?filters[roles]=ROLE_WORKER&filters[visibleInCalendar]=1&sortCol=calendarPriority&sortDir=ASC`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getById(id: string) {
        return this.http.get<User>(`${environment.apiEndpoint}/v1/user/${id}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getByCardNumber(cardNumber: string) {
        return this.http.get<User>(`${environment.apiEndpoint}/v1/user/by-card-number/${cardNumber}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    update(id, params) {
        return this.http.put(`${environment.apiEndpoint}/v1/user/${id}`, params, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map(x => {
                return x;
            }));
    }

    create(params) {
        if (!params.roles.includes('ROLE_TRAINER')) {
            params.roles = ['ROLE_WORKER'];
        }
        return this.http.post(`${environment.apiEndpoint}/v1/user`, params, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map(x => {
                return x;
            }));
    }

    updateCustomer(id, params, formValues) {
        params.append('plainPassword', '1qaz2wsxjdsifjf99f9fsd');
        params.append('roles[]', 'ROLE_CUSTOMER');

        if (typeof formValues.birthdayYear != "undefined" && typeof formValues.birthdayMonth != "undefined" && formValues.birthdayDay != "undefined") {
            params.append('birthday', formValues.birthdayYear + '-' + formValues.birthdayMonth + '-' + formValues.birthdayDay);
        }

        if (typeof formValues.nameDayDay != "undefined" && typeof formValues.nameDayMonth != "undefined") {
            params.append('nameDay', '2000-' + formValues.nameDayMonth + '-' + formValues.nameDayDay);
        }

        return this.http.post(`${environment.apiEndpoint}/v1/user/${id}`, params, {
            headers: new HttpHeaders({
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map(x => {
                return x;
            }));
    }

    createCustomer(params) {
        params.plainPassword = '1qaz2wsxjdsifjf99f9fsd';
        params.roles = ['ROLE_CUSTOMER'];

        if (typeof params.birthdayYear != "undefined" && typeof params.birthdayMonth != "undefined" && params.birthdayDay != "undefined") {
            params.birthday = params.birthdayYear + '-' + params.birthdayMonth + '-' + params.birthdayDay;
        }

        if (typeof params.nameDayDay != "undefined" && typeof params.nameDayMonth != "undefined") {
            params.nameDay = '2000-' + params.nameDayMonth + '-' + params.nameDayDay;
        }

        return this.http.post(`${environment.apiEndpoint}/v1/user`, params, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map(x => {
                return x;
            }));
    }

    createCustomerFromForm(params, formValues) {
        params.plainPassword = '1qaz2wsxjdsifjf99f9fsd';
        params.roles = ['ROLE_CUSTOMER'];

        if (typeof formValues.nameDayDay != "undefined" && typeof formValues.nameDayMonth != "undefined") {
            params.append('nameDay', '2000-' + params.nameDayMonth + '-' + params.nameDayDay);
        }

        return this.http.post(`${environment.apiEndpoint}/v1/user`, params, {
            headers: new HttpHeaders({
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map(x => {
                return x;
            }));
    }

    delete(id: string) {
        return this.http.delete(`${environment.apiEndpoint}/v1/user/` + id, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map(x => {
                return x;
            }));
    }
}
